"use client";
import styles from "@/styles/About.module.css";
import Link from "next/link";
import Image from "next/image";

export default function About() {
  return (
    <>
      <Link href="/" id="homeButton" className={styles.homeButton}>
        <span className="material-symbols-rounded">home</span>
      </Link>

      <div className={styles.section}>
        <div className={styles.sectionWrapper}>
          <div className={styles.contentWrapper}>
            {/* Content 1 */}
            <div className={`${styles.content} ${styles.content1}`}>
              <div className={styles.mobileVisual}>
                <Image
                  src="/images/ricapic.png"
                  alt="RICA"
                  width={300}
                  height={300}
                  className={styles.cardImg}
                />
              </div>
              <div className={styles.meta}>
                <h2 className={styles.headline}>
                  <span className={styles.textHighlight}>ABOUT RICA</span>
                </h2>
                <p className={styles.desc}>
                  RICA is a chatbot of Republic Central Colleges, built by its
                  BSIT students in 2025 aimed at delivering faster responses to
                  common inquiries and improving access to information for both
                  the campus community and external stakeholders.
                </p>
              </div>
            </div>

            {/* Content 2 */}
            <div className={`${styles.content} ${styles.content2}`}>
              <div className={styles.mobileVisual}>
                <Image
                  src="/images/itpic.png"
                  alt="IT"
                  width={300}
                  height={300}
                  className={styles.cardImg}
                />
              </div>
              <div className={styles.meta}>
                <h2 className={styles.headline}>
                  <span className={styles.textHighlight}>OBJECTIVE</span>
                </h2>
                <p className={styles.desc}>
                  The objective of this study is to improve the management of
                  inquiries within the school for all stakeholders—students,
                  parents, teachers, administrators, and staff. Additionally, it
                  aims to generate marketing leads to promote Republic Central
                  Colleges by designing and developing a specialized chatbot
                  tailored to the institution.
                </p>
              </div>
            </div>

            {/* Content 3 */}
            <div className={`${styles.content} ${styles.content3}`}>
              <div className={styles.mobileVisual}>
                <Image
                  src="/images/rccpic.png"
                  alt="RCC"
                  width={300}
                  height={300}
                  className={styles.cardImg}
                />
              </div>
              <div className={styles.meta}>
                <h2 className={styles.headline}>
                  <span className={styles.textHighlight}>
                    EDUCATIONAL IMPACT
                  </span>
                </h2>
                <p className={styles.desc}>
                  RICA AI is designed to transform the educational experience by
                  providing a comprehensive, AI-driven platform for students,
                  faculty, and administration. For students, RICA AI serves as
                  an accessible virtual assistant, answering inquiries related
                  to upcoming events, tuition fees, schedules, and more based on
                  the college's information (RCC).
                </p>
              </div>
            </div>

            {/* Content 4 */}
            <div className={`${styles.content} ${styles.content4}`}>
              <div className={styles.mobileVisual}>
                <Image
                  src="/images/grouppicc.png"
                  alt="Team"
                  width={300}
                  height={300}
                  className={styles.cardImg}
                />
              </div>
              <div className={styles.meta}>
                <h2 className={styles.headline}>
                  <span className={styles.textHighlight}>
                    ORIGIN OF RICA AI
                  </span>
                </h2>
                <p className={styles.desc}>
                  RICA AI is an innovative project created by a group of
                  fourth-year IT students, each contributing their unique skills
                  and perspectives. The name RICA represents the initials of the
                  creators: R for Ren Jion Lin, I for Ivan Pare, C for Chloie
                  Calara, and A for Amare Dayrit.
                </p>
              </div>
            </div>
          </div>

          {/* Visual */}
          <div className={styles.visual}>
            <div className={styles.cardWrapper}>
              <div className={`${styles.card} ${styles.card1}`}>
                <Image
                  src="/images/ricapic.png"
                  alt="RICA"
                  width={500}
                  height={500}
                  className={styles.cardImg}
                />
              </div>
              <div className={`${styles.card} ${styles.card2}`}>
                <Image
                  src="/images/itpic.png"
                  alt="IT"
                  width={500}
                  height={500}
                  className={styles.cardImg}
                />
              </div>
              <div className={`${styles.card} ${styles.card3}`}>
                <Image
                  src="/images/rccpic.png"
                  alt="RCC"
                  width={500}
                  height={500}
                  className={styles.cardImg}
                />
              </div>
              <div className={`${styles.card} ${styles.card4}`}>
                <Image
                  src="/images/grouppicc.png"
                  alt="Team"
                  width={500}
                  height={500}
                  className={styles.cardImg}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
